import { render, staticRenderFns } from "./authModal.vue?vue&type=template&id=6ed960dc&scoped=true"
import script from "./authModal.vue?vue&type=script&lang=js"
export * from "./authModal.vue?vue&type=script&lang=js"
import style0 from "./authModal.vue?vue&type=style&index=0&id=6ed960dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed960dc",
  null
  
)

export default component.exports